<header>
  <div class="inner-page-header">
    <div class="inner-page-header-in">
      <div class="row pr-sm-3 mx-0">
        
        <div class="col-3">
          <button class="btn-clear btn-menu" (click)="toggleMenu()">
            <i class="ic-menu"></i>
          </button>
        </div>

        <div class="col-9 mx-auto">
          <div class="float-end">

            <!-- <div class="float-start mx-2 notification-cnt">
              <button class="btn-clear btn-notification" [ngClass]="{ active: isOpen }" (click)="isOpen = !isOpen">
                <i class="ic-notification new-notify"> </i>
                <span class="notification-active"></span>
              </button>
              <div class="notification-list" [ngClass]="{ open: isOpen }" (clickOutside)="closeNotifications($event)">
                <div class="card">
                  <div class="card-header">
                    <span class="title-text">Notifications</span>
                  </div>
                  <div class="card-content">
                    <ng-scrollbar class="notification-listing">
                      <ul>

                      </ul>
                      <div class="v-mid-cnt" *ngIf="
                        !userInfo.notifications || !userInfo.notifications.length
                      ">
                        <div class="v-mid-cnt-inner">
                          <div class="img-cnt">
                            <img src="assets/images/notification-off.png" />
                          </div>
                          <p>No Notification found!</p>
                        </div>
                      </div>
                    </ng-scrollbar>
                  </div>
                  <div class="card-footer" *ngIf="userInfo.notifications && userInfo.notifications.length">
                    <button class="btn-clear btn-view-all">
                      View All Notification
                    </button>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="float-end profile-dropdown">
              <button mat-button [matMenuTriggerFor]="userMenu" class="btn-clear d-flex align-items-center">
                <span class="user-pic me-2">
                  <img [src]="userInfo.logo ? userInfo.logo : 'assets/images/edit-profile-pic.png'"
                    class="rounded-circle" width="40" height="40" alt="User" />
                </span>
                <span class="user-name text-truncate">{{ userInfo.userName }}</span>
                <span class="arrow-down mx-auto"></span>
              </button>

              <!-- Menu Content -->
              <mat-menu #userMenu="matMenu" class="user-menu-dropdown mat-elevation-z4">
                <!-- Profile Info -->
                <div class="user-profile-info px-3 py-2 border-bottom">
                  <div class="d-flex align-items-center">
                    <div class="profile-thumb me-3">
                      <img [src]="userInfo.logo ? userInfo.logo : 'assets/images/edit-profile-pic.png'"
                        class="rounded-circle" width="50" height="50" alt="Profile" />
                    </div>
                    <div class="inner-profile-det">
                      <h6 class="mb-0 fw-bold text-dark" [innerHTML]="userInfo.username"></h6>
                      <small class="text-muted" [innerHTML]="userInfo.email"></small>
                    </div>
                  </div>
                </div>

                <!-- Menu Items -->
                <button mat-menu-item (click)="editProfile()" class="d-flex align-items-center">
                  <i class="ic-male me-2 text-primary"></i> Edit
                </button>

                <button mat-menu-item (click)="changePassword()" class="d-flex align-items-center">
                  <i class="ic-pwd me-2 text-warning"></i> Change Password
                </button>

                <button mat-menu-item (click)="logout()" class="d-flex align-items-center text-danger">
                  <i class="fa fa-sign-out me-2"></i> Logout
                </button>
              </mat-menu>
            </div>

          </div>
        </div>
        
      </div>
    </div>
  </div>
</header>